import React from 'react'
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { fetchShipback } from '../actions/shipback'

class ReturnTracking extends React.Component {

  constructor(props) {
    super()
    this.props = props
  }

  componentWillMount() {
    this.props.fetchShipback(shipback_id, this.props.user_token, true)
  }

  render() {
    var transiting_condition = ["delivering", "delivered", "relocating", "identified"].includes(this.props.shipback.state)
    var created = ["created", "registering", "registered"].includes(this.props.shipback.state) ? "row status first active" : "row status first"
    var transit_instruction = transiting_condition ? "active" : "upcoming"
    var transit = transiting_condition ? "row status active" : "row status"
    var relocated_intruction = this.props.shipback.state == "relocated" ? "active" : "upcoming"
    var relocated = this.props.shipback.state == "relocated" ? "row status last active" : "row status last"

    if (transiting_condition) {
      created += " active"
    }
    if (this.props.shipback.state == "relocated") {
      created += " active"
      transit += " active"
    }
    return (
      <div className="tracking">
        <div className="statuses mt-5">
          <div className={created}>
            <span className="col-3">
              <span className="jauge pull-right"></span>
            </span>
            <span className="col-1 status-icon">
              <i className="fa fa-list" />
            </span>
            <div className="col-6 status-information">
              <p className="name">{I18n.t('shipbacks.trackings.index.statuses.created.name')}</p>
              <p className="instructions">{I18n.t('shipbacks.trackings.index.statuses.created.instructions.active')}</p>
            </div>
          </div>
          <div className={transit}>
            <span className="col-3">
              <span className="jauge pull-right"></span>
            </span>
            <span className="col-1 status-icon">
              <i className="fa fa-truck" />
            </span>
            <div className="col-6 status-information">
              <p className="name">{I18n.t('shipbacks.trackings.index.statuses.transit.name')}</p>
              <p className="instructions">{I18n.t('shipbacks.trackings.index.statuses.transit.instructions.' + transit_instruction)}</p>
            </div>
          </div>
          <div className={relocated}>
            <span className="col-3">
              <span className="jauge pull-right"></span>
            </span>
            <span className="col-1 status-icon">
              <i className="fa fa-home" />
            </span>
            <div className="col-6 status-information">
              <p className="name">{I18n.t('shipbacks.trackings.index.statuses.relocated.name')}</p>
              <p className="instructions">{I18n.t('shipbacks.trackings.index.statuses.relocated.instructions.' + relocated_intruction)}</p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  shipback: state.shipback,
  user_token: state.user,
})

const mapDispatchToProps = dispatch => bindActionCreators({ fetchShipback }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ReturnTracking)


// WEBPACK FOOTER //
// ./app/javascript/components/components/ReturnTracking.jsx